import { render, staticRenderFns } from "./ApiKeys.vue?vue&type=template&id=0d634924&scoped=true"
import script from "./ApiKeys.vue?vue&type=script&lang=ts"
export * from "./ApiKeys.vue?vue&type=script&lang=ts"
import style0 from "./ApiKeys.vue?vue&type=style&index=0&id=0d634924&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d634924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d634924')) {
      api.createRecord('0d634924', component.options)
    } else {
      api.reload('0d634924', component.options)
    }
    module.hot.accept("./ApiKeys.vue?vue&type=template&id=0d634924&scoped=true", function () {
      api.rerender('0d634924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/ApiKeys.vue"
export default component.exports